import React from 'react';
import { connect } from 'react-redux';

import {
  CONTAINER,
  ROW,
  COLUMN,
  ELEMENT,
} from '../element-categories';

import {
  LOGO,
  MENU,
  SOCIAL_MEDIA,
  BUTTON,
  IMAGE,
  SEARCH,
  LANGUAGE_SELECTOR,
  SHOPPING_ICON,
  NAVIGATION,
  DIVIDER,
  TEXTBOX,
} from '../element-types';

import {remove} from '../actions/general-actions'
import Icon from './Icon';
import styles from '../../../../stylesheet/css/header-builder/remove-element.css';

const getRemoveElementIcon = (props) => {
  switch(props.category) {
    case CONTAINER:
    case COLUMN:
      return '';
    case ROW:
      return <Icon icon="trash-shortcut" w="9px" h="9px" vb="0 0 9 9"/>;
    case ELEMENT:
      switch(props.type) {
        case LOGO:
        case MENU:
        case SOCIAL_MEDIA:
        case BUTTON:
        case IMAGE:
        case SEARCH:
        case LANGUAGE_SELECTOR:
        case SHOPPING_ICON:
        case NAVIGATION:
        case DIVIDER:
        case TEXTBOX:
          return <Icon icon="trash-shortcut" w="9px" h="9px" vb="0 0 9 9"/>;
        default:
          return '';
      }
    default:
      return '';
  }
};

const removeElementOption = ({ device, highlightedElementModel, onElementRemove }) => {
  let getRemoveIcon = getRemoveElementIcon(highlightedElementModel);
  if(getRemoveIcon != ''){
    return (
      <a onClick={onElementRemove} className={styles.removeElement}>
        {getRemoveIcon}
      </a>
    );
  }else {
    return null;
  }
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device, id } = ownProps;
  return {
    onElementRemove() {
      dispatch(remove({device, id:ownProps.highlightedElementModel.id}));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(removeElementOption);


// WEBPACK FOOTER //
// ./app/header-builder/components/RemoveElement.js